<template>
  <v-dialog
    ref="updateTextDialog"
    v-model="localdialog"
    max-width="600px"
    persistent
    transition="dialog-bottom-transition"
    class="dialog-zindex"
  >
    <template #activator="{ on }">
      <CotizadorBtn
        v-if="!withoutActivator"
        dark
        :on="on"
        :disabled="disabled"
        content-class="w-100"
      >
        <img
          class="ma-2 btn-icon-presupuesto"
          src="@/assets/cart.svg"
          alt="cart"
        />
        <span>{{ $t("general.updTxt.btn") }}</span>
      </CotizadorBtn>
    </template>

    <v-card>
      <v-card-text>
        <v-col class="disenoBody">
          <!-- Añadir diseño -->
          <v-row class="mt-1">
            <v-col>
              <span>{{ $t("general.updTxt.addText") }}</span>
              <div class="d-flex">
                <v-text-field 
                  v-model="textDesing" 
                  :disabled="disabled" 
                  :loading="loading" 
                  class="mt-2 mr-2" 
                  filled 
                  dense 
                  clearable
                ></v-text-field>
                <div class="mt-2">
                  <ColorPicker v-model="colorPicker" />
                </div>
              </div>
            </v-col>
          </v-row>
          <v-row class="mt-1">
            <v-col>
              <span>{{ $t("general.updTxt.selectFont") }}</span>
              <v-select
                v-model="selectedFont" 
                outlined
                dense
                hide-details
                item-text="name"
                item-value="id"
                :items="fontList"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <span>
                {{ $t("general.updTxt.infoText") }}
              </span>
            </v-col>
          </v-row>
        </v-col>
      </v-card-text>
      <v-card-actions>
        <v-btn color="primary" text @click="closeDialog">
          {{ $t("general.Cancelar") }}
        </v-btn>
        <v-btn color="primary" text @click="saveFileAndCloseDialog">
          {{ $t("general.Guardar") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import CotizadorBtn from "@/components/basic/CotizadorBtn.vue";
import ColorPicker from "@/components/basic/ColorPicker.vue";

export default {
  name: "CotizadorTexto",
  components: {
    CotizadorBtn,
    ColorPicker
  },
  props: {
    withoutActivator: {
      type: Boolean,
      default: false
    },
    dialog: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: [Boolean, String],
      default: false
    },
    zona: {
      type: Object,
      required: true
    },
  },
  data() {
    return {
      localdialog: false,
      idImg: 0,
      loading: false,
      eliminando: false,
      
      // Datos del formulario
      textDesing: '',
      selectedFont: 1,
      colorPicker: '#000000',
      
      // Datos originales para comparar cambios
      originalText: '',
      originalFont: 1,
      originalColor: null, // Inicializar en null para distinguir "sin color" de "negro"
      
      hasChanges: false, 
      
      fontList: [
        {"id":1,"name":"Impact"},{"id":2,"name":"Collegiate"},{"id":6,"name":"Aclonica"},
        {"id":7,"name":"Arial Black"},{"id":8,"name":"Arial"},{"id":9,"name":"Monotype Corsiva"},
        {"id":14,"name":"HelveticaNeue_Bold"},{"id":16,"name":"Montserrat Black_Regular"},
        {"id":18,"name":"Montserrat_Bold"},{"id":19,"name":"Bebas Neue_Regular"}
      ]
    }
  },
  computed: {
    ...mapGetters("modelo", ["modelCode"]),
    ...mapGetters("design", ["actualListDesign", "getDesignByIdAndZone"]),
  },
  watch: {
    dialog(newVal) {
      if (this.localdialog !== newVal) {
        this.localdialog = newVal;
      }
    },
    localdialog(newVal, oldVal) {
      if (newVal === oldVal) return;

      if (newVal !== this.dialog) {
        this.$emit("update:dialog", newVal);
      }

      if (!newVal) {
        this.$emit("close-dialog");
      }

      if (newVal && !oldVal) {
        this.resetImg();
        // Carga inmediata sin setTimeout
        this.$nextTick(() => {
            this.tryInitializeFromDesignList();
        });
      }
    },
    // Watchers para detectar cambios en tiempo real
    textDesing(newVal) {
      this.checkForChanges();
      if ((newVal === '' || newVal == null) && this.originalText && newVal !== this.originalText) {
        this.eliminando = true;
      } else {
        this.eliminando = false;
      }
    },
    selectedFont() {
      this.checkForChanges();
    },
    colorPicker() {
      this.checkForChanges();
    }
  },
  methods: {
    ...mapActions("design", ["deleteZoneCustomDesign"]),
    
    checkForChanges() {
        // Comparación estricta. Nota: originalColor puede ser undefined en diseños viejos.
        // Si design no tenía color (undefined) y ahora es #000000, cuenta como cambio.
        const changedText = this.textDesing !== this.originalText;
        const changedFont = this.selectedFont !== this.originalFont;
        const changedColor = this.colorPicker !== this.originalColor;
        
        this.hasChanges = changedText || changedFont || changedColor;
    },

    deleteImg() {
      this.eliminando = true;
      this.resetImg();
    },

    resetImg() {
      this.idImg = 0;
      this.textDesing = "";
      this.selectedFont = this.fontList[0]?.id ?? 1;
      this.colorPicker = '#000000';
      
      this.originalText = "";
      this.originalFont = this.fontList[0]?.id ?? 1;
      this.originalColor = '#000000';
      
      this.hasChanges = false;
      this.eliminando = false;
    },

    closeDialog() {
      this.localdialog = false;
    },

    generateIdPersonalization() {
      return Math.floor(Math.random() * 2147483647);
    },

    saveFile() {
      console.log("🚀 ~ this.eliminando:", this.eliminando)
      if (this.eliminando) {
        this.$emit("update-image", null);
        return;
      }

      // Si no hay cambios, no hacemos nada (evita spam de IDs sin motivo)
      console.log("🚀 ~ this.hasChanges:", this.hasChanges)
      if (!this.hasChanges) {
        return;
      }

      // IMPORTANTE: Generar NUEVO ID si hubo cambios (incluido cambio de color)
      // Esto fuerza al Canvas 3D a recargar la textura
      this.idImg = this.generateIdPersonalization();
      this.hasChanges = false;

      this.$emit("update-image", {
        id: this.idImg,
        zona: this.zona,
        textDesign: this.textDesing,
        fontSelected: this.selectedFont,
        colorPicker: this.colorPicker
      });

      // Actualizamos los "originales" al nuevo estado guardado
      this.originalText = this.textDesing;
      this.originalFont = this.selectedFont;
      this.originalColor = this.colorPicker;
    },

      saveFileAndCloseDialog() {
        console.log("TEST")
      const isDeleting = this.eliminando;
      this.closeDialog();

      if (isDeleting) {
        this.$emit("update-image", null);
        this.deleteZoneCustomDesign({
          id: this.zona?.id,
          posicion: this.zona.Posicion
        });
        this.eliminando = false;
        return;
      }

      this.saveFile();
    },

    getFontId(fontDesign) {
      if (!this.fontList || this.fontList.length === 0) return 1;
      if (fontDesign == null) return this.fontList[0].id;

      if (typeof fontDesign === 'number') {
        const found = this.fontList.find(f => f.id === fontDesign);
        if (found) return fontDesign;
      }

      if (typeof fontDesign === 'string') {
        const byName = this.fontList.find(f => f.name === fontDesign);
        if (byName) return byName.id;

        const parsed = parseInt(fontDesign, 10);
        if (!isNaN(parsed)) {
          const byId = this.fontList.find(f => f.id === parsed);
          if (byId) return byId.id;
        }
      }
      return this.fontList[0].id;
    },

    tryInitializeFromDesignList() {
      if (this.disabled) return;
      this.loading = true;
      
      // Sin setTimeout para evitar condiciones de carrera si el usuario edita rápido
      if (this.actualListDesign && this.actualListDesign.length > 0) {
        let design = this.getDesignByIdAndZone({ id: this.zona?.id ?? -1, posicion: this.zona.Posicion });

        if (design) {
            this.idImg = design.idImg || this.generateIdPersonalization();
            this.textDesing = design.textDesign || "";
            
            // Lógica crítica para el color:
            // 1. Obtenemos el valor crudo del diseño (puede ser undefined en diseños viejos)
            const rawDesignColor = design.colorPicker;
            
            // 2. Seteamos el valor del picker (Si es undefined, fallback a negro para la UI)
            this.colorPicker = rawDesignColor || '#000000';
            
            // 3. Seteamos el original EXACTAMENTE como viene del diseño
            // Esto permite que si rawDesignColor es undefined y colorPicker es #000000,
            // checkForChanges() detecte diferencia y permita guardar.
            this.originalColor = rawDesignColor; 

            const resolvedFontId = this.getFontId(design.fontDesign);
            this.selectedFont = resolvedFontId;
            this.originalFont = resolvedFontId;
            this.originalText = this.textDesing;

            // Recalculamos cambios inmediatamente por si la normalización generó diferencias
            this.checkForChanges();
        } else {
            this.resetImg();
        }
      } else {
        this.resetImg();
      }
      
      this.loading = false;
    }
  }
}
</script>